import { Controller } from '@hotwired/stimulus';

const FADE_SPEED_STYLE = '.25S';
const FADE_SPEED_MS = 250;

export default class extends Controller {
  static targets = ['step']

  connect() {
    this.element.style.setProperty('--animate-duration', FADE_SPEED_STYLE);
    this.step = 0;
  }

  next(e) {
    e.preventDefault();
    this.changePage(1);
  }

  prev(e) {
    e.preventDefault();
    this.changePage(-1);
  }


  changePage(dir) {
    const currentStep = this.step;
    this.step += dir;
    this.fadeOut(this.stepTargets[currentStep], () => {
      this.fadeIn(this.stepTargets[this.step]);
    });
  }

  fadeIn(node) {
    node.classList.remove('d-none');
    node.classList.add('animate__animated', 'animate__fadeIn');
  }

  fadeOut(node, callback) {
    node.classList.add('animate__animated', 'animate__fadeOut');
    setTimeout(() => {
      node.classList.add('d-none');
      node.classList.remove('animate__animated', 'animate__fadeOut');
      callback();
    }, FADE_SPEED_MS);
  }
}
